import { invoiceNotificationRuleService } from "src/services/api";

const state = {
  status: {},
  errors: [],
  statusText: "",
  data: [],
};

const actions = {
  async getAll({ commit, dispatch }) {
    await invoiceNotificationRuleService.getAll().then(
      (response) => {
        commit("setData", response.data);
      },
      (error) => {
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async create({ commit, dispatch }, payload) {
    await invoiceNotificationRuleService.create(payload).then(
      (response) => {
        commit("createSuccess", response);
        commit("appendData", payload);
        dispatch(
          "snackbar/success",
          `Create Invoice Reminder "${payload.name}" successful`,
          { root: true }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async update({ commit, dispatch }, payload) {
    await invoiceNotificationRuleService.update(payload).then(
      (response) => {
        commit("updateSuccess", response);
        commit("updateData", payload);
        dispatch(
          "snackbar/success",
          `Update Invoice Reminder "${payload.name}" successful`,
          { root: true }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async delete({ commit, dispatch }, payload) {
    await invoiceNotificationRuleService.delete(payload).then(
      (response) => {
        commit("deleteSuccess", response);
        commit("deleteData", payload);
        dispatch(
          "snackbar/success",
          `Delete Invoice Reminder "${payload.name}" successful`,
          { root: true }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },
};

const mutations = {
  setData(state, data) {
    state.data = data;
  },

  appendData(state, item) {
    state.data.push(item);
  },

  updateData(state, item) {
    const index = state.data.findIndex((data) => data.id === item.id);
    if (index !== -1) state.data.splice(index, 1, item);
  },

  deleteData(state, item) {
    state.data.splice(state.data.indexOf(item.id), 1);
  },

  createSuccess(state, response) {
    state.statusText = "create-ok";
    state.status = { error: false, message: response.message };
  },

  deleteSuccess(state, response) {
    state.statusText = "delete-ok";
    state.status = { error: false, message: response.message };
  },

  updateSuccess(state, response) {
    state.statusText = "update-ok";
    state.status = { error: false, message: response.message };
  },

  createFailure(state, response) {
    state.statusText = "create-error";
    state.status = { error: true, message: response.message };
  },
};

const getters = {
  getAllFromLatest(state) {
    return state.data.reverse();
  },
};

export const invoiceNotificationRule = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
